import ApiService from "@/core/services/api.service";
import {PURGE_AUTH} from "./auth.module";
import JwtService from "@/core/services/jwt.service";
import {SET_PAGINATE} from "./paginate.module";

// action types
export const ADD_PRODUCT = "addProduct";
export const GET_PRODUCTS = "getProducts";
export const GET_PRODUCT = "getProduct";
export const UPDATE_PRODUCT = "updateProduct";
export const GET_TRANSLATE = "GetTranslate";
export const DELETE_PRODUCT = "deleteProduct";
export const MORE_DELETE_PRODUCTS = "moreDeleteProducts";
export const FORCE_DELETE_PRODUCT = "forceDeleteProduct";
export const MORE_FORCE_DELETE_PRODUCT = "moreForceDeleteProduct";
export const RESTORE_PRODUCT = "restoreProduct";
export const MORE_RESTORE_PRODUCTS = "moreRestoreProduct";

// mutation types
export const SET_PRODUCTS_ERROR = "setErrors";
export const SET_PRODUCTS = "setProducts";
export const SET_PRODUCT = "setProduct";
export const SET_PRODUCT_LOAD = "setProductLoad";
export const SET_CODE = "setCode";
export const NEW_PRODUCT = "newProduct";


const state = {
    errors: {},
    products: [],
    load: false,
    product: {
        images: [],

        cities: [],
        description:'',
        short_description: '',

        unit_of_measure: '',
        weight: 0,
        unit_weight: 0,
        volume: 0,
        unit_volume: 0,
        minimum_lot: 1,

        meta_title: '',
        meta_description: '',

        title: '',
        code: '',
        price: '',
        sku: '',
        stock: 0,
        categories: [],
        sub_categories: [],
        sub_sub_categories: [],

        type: 'for_order',

        new: false,
        sale: false,
        discount: 0,

        attributes: [],
        variants: [],

        factory_name: '',
        factory_address: '',
        factory_contact_name: '',
        factory_contact: '',
        factory_link: '',


    },
    attributes_val: [],
    code:''
};

const getters = {
    gettersProducts(state) {
        return state.products;
    },
    gettersProduct(state) {
        return state.product;
    },
    errorsProducts(){
        return state.errors;
    },
    getProductLoad(){
        return state.load;
    },
    getProductCode(){
        return state.code;
    },
    getProductVariants(){
        return state.product.variants;
    }
};

const actions = {


    [GET_TRANSLATE](context, title){
        return new Promise((resolve, reject) => {
            context.commit(SET_PRODUCTS_ERROR, {});
            ApiService.post("/product/translate", title)
                .then(({ data }) => {
                    resolve(data);
                    context.commit(SET_CODE, data);
                })
                .catch(({ response }) => {
                    reject(response);
                    context.commit(SET_PRODUCTS_ERROR, response.data.errors);

                });

        });
    },

    [ADD_PRODUCT](context, data){
        return new Promise((resolve, reject) => {
            context.commit(SET_PRODUCTS_ERROR, {});
            ApiService.post("/product/store", data)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                    if (response.status === 422){
                        context.commit(SET_PRODUCTS_ERROR, response.data.errors);
                    }
                });
        });
    },


    [GET_PRODUCTS](context, data) {

        return new Promise((resolve, reject) => {
            context.commit(SET_PRODUCT_LOAD, true);
            ApiService.post("/products", data)
                .then(({ data }) => {
                    resolve(data);
                    context.commit(SET_PRODUCTS, data);
                    context.commit(SET_PAGINATE, data);
                    context.commit(SET_PRODUCT_LOAD, false);
                })
                .catch(({ response }) => {
                    reject(response);
                    context.commit(SET_PRODUCTS_ERROR, response.data.errors);
                    context.commit(SET_PRODUCT_LOAD, false);
                });
        });
    },

    [GET_PRODUCT](context, id) {
        context.commit(SET_PRODUCT_LOAD, true);
        return new Promise((resolve, reject) => {
        ApiService.get("/product", id)
            .then(({ data }) => {
                resolve(data);
                context.commit(SET_PRODUCT, data);
                context.commit(SET_PRODUCT_LOAD, false);
            })
            .catch(({ response }) => {
                reject(response);
                context.commit(SET_PRODUCTS_ERROR, response.data.errors);
                context.commit(SET_PRODUCT_LOAD, false);
            });
        });
    },


    [UPDATE_PRODUCT](context, data) {
        if (JwtService.getToken()) {
            return new Promise((resolve, reject) => {
                ApiService.update("/product/update", data.id, data.product)
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_PRODUCTS_ERROR, {});
                    })
                    .catch(({ response }) => {
                        reject(response);
                        if (response.status === 422){
                            context.commit(SET_PRODUCTS_ERROR, response.data.errors);
                        }
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }

    },


    [DELETE_PRODUCT](context, id) {
        if (JwtService.getToken()) {
            return new Promise((resolve, reject) => {
                ApiService.delete("/product/soft-delete", id)
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_PRODUCTS_ERROR, {});
                    })
                    .catch(({ response }) => {
                        reject(response);
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }
    },

    [MORE_DELETE_PRODUCTS](context, ids) {
        if (JwtService.getToken()) {
            return new Promise((resolve, reject) => {
                ApiService.post("/product/more-soft-delete", ids)
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_PRODUCTS_ERROR, {});
                    })
                    .catch(({ response }) => {
                        reject(response);
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }
    },

    [FORCE_DELETE_PRODUCT](context, id) {
        if (JwtService.getToken()) {
            return new Promise((resolve, reject) => {
                ApiService.delete("/product/force-delete", id)
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_PRODUCTS_ERROR, {});
                    })
                    .catch(({ response }) => {
                        reject(response);
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }
    },

    [MORE_FORCE_DELETE_PRODUCT](context, ids) {
        if (JwtService.getToken()) {
            return new Promise((resolve, reject) => {
                ApiService.post("/product/more-force-delete", ids)
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_PRODUCTS_ERROR, {});
                    })
                    .catch(({ response }) => {
                        reject(response);
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }
    },



    [RESTORE_PRODUCT](context, id){
        if (JwtService.getToken()) {
            return new Promise((resolve, reject) => {
                ApiService.get("/product/restore", id)
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_PRODUCTS_ERROR, {});
                    })
                    .catch(({ response }) => {
                        reject(response);
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }
    },


    [MORE_RESTORE_PRODUCTS](context, ids) {
        if (JwtService.getToken()) {
            return new Promise((resolve, reject) => {
                ApiService.post("/product/more-restore", ids)
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_PRODUCTS_ERROR, {});
                    })
                    .catch(({ response }) => {
                        reject(response);
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }
    },

};

const mutations = {
    [SET_PRODUCTS_ERROR](state, error) {
        state.errors = error;
    },

    [SET_PRODUCTS](state, data) {
        state.products = data.data;
    },

    [SET_PRODUCT](state, product) {
        state.product = product.product;
        state.attributes_val = product.attributes_val;
    },

    [SET_PRODUCT_LOAD](state, load) {
        state.load = load;
    },

    [SET_CODE](state, code){
        state.code = code.code;
    },

    [NEW_PRODUCT](state){
        state.product = {
            images: [],

            cities: [],
            description:'',
            short_description: '',

            unit_of_measure: '',
            weight: 0,
            unit_weight: 0,
            volume: 0,
            unit_volume: 0,
            minimum_lot: 1,

            meta_title: '',
            meta_description: '',

            title: '',
            code: '',
            price: '',
            sku: '',
            stock: 0,
            categories: [],
            sub_categories: [],
            sub_sub_categories: [],

            type: 'for_order',

            new: false,
            sale: false,
            discount: 0,

            attributes: [],
            variants: [],

            factory_name: '',
            factory_address: '',
            factory_contact_name: '',
            factory_contact: '',
            factory_link: '',
        }
    }

};

export default {
    state,
    actions,
    mutations,
    getters
};
